import { SlackChannels } from '../../pure-js/enums/SlackChannels.js'
import config from '../src/Config.js'
import { sendSlackNotification } from './libs/CloudFunctionsApiHandler.js'

export const slack = (mrkDown: string, channel: SlackChannels): Promise<unknown> => {
  if (!config.enableSlack) return Promise.resolve(console.log(`\n#${channel}\n`, mrkDown))
  return sendSlackNotification({ text: mrkDown, channel }).catch(
    () => ({}) // if slack borks then unhandled promise rejection will throw slack messag => infinite loop => slack turns off integration
  )
}
